import React from "react";
import PopupWrapper from "components/common/PopupWrapper";
import UnitsSelector from "components/common/UnitsSelector";
import PriceUnit from "components/ops-mgmt/account/upr-segmentation/PriceUnit";

class UprSegmentInfoPopover extends React.Component {
  render() {
    const {
      networkId,
      segment,
      triggerElement,
      place = "bottom",
      onOpen,
      onClose,
    } = this.props;

    return (
      <PopupWrapper
        place={place}
        triggerType="click"
        hideArrow={false}
        triggerElement={triggerElement}
        onOpen={onOpen}
        onClose={onClose}
        popupElement={
          <div
            className="shadow border p-4"
            style={{ width: "600px", maxHeight: "600px", overflow: "auto" }}
          >
            {segment ? (
              <UprSegmentInfoView data={segment} networkId={networkId} />
            ) : (
              <div className="text-gray-800">No data found.</div>
            )}
          </div>
        }
      ></PopupWrapper>
    );
  }
}

class UprSegmentInfoView extends React.Component {
  render() {
    const { data, networkId } = this.props;
    const { id, name, optimization, traffic_scope = "ALL" } = data;

    const isDt = optimization === "dt";
    const unitSettings = data.unit_segmented_price_settings || [];

    return (
      <div className="flex flex-col gap-4">
        <Title>
          {id} - {name}
        </Title>
        <div className="border-b">
          <Title>Optimization</Title>
          <div className="text-sm">{optimization}</div>
        </div>
        <div className="border-b">
          <Title>Traffic Scope</Title>
          <div className="text-sm">{traffic_scope}</div>
        </div>

        <div>
          <Title>Price Section</Title>
          <div className="bg-gray-200 p-2">
            {isDt ? (
              <>
                <Title>Price</Title>
                <div className="text-sm">--</div>
              </>
            ) : (
              <PriceItem prices={data.prices} title="Price" />
            )}
            <PriceItem prices={data.detector_prices} title="Detector Prices" />
            <PriceItem prices={data.catchall_prices} title="Catchall Prices" />
            <PriceItem prices={data.x_prices} title="X Prices" />
          </div>
        </div>

        <div>
          <Title>
            Unit Settings
            {isDt ? "" : ` (${unitSettings.length})`}
          </Title>
          <div className="text-sm">
            {isDt || unitSettings.length === 0 ? (
              "--"
            ) : (
              <UnitSettingsView data={unitSettings} networkId={networkId} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

class PriceItem extends React.PureComponent {
  render() {
    const { prices, title } = this.props;

    return (
      <div>
        <div className="font-semibold text-gray-800">
          {title}: {prices ? `(${prices.length})` : ""}
        </div>
        <div className="flex w-full flex-wrap gap-1 pb-1">
          {prices
            ? prices.map((p, idx) => {
                return (
                  <PriceUnit
                    price={p}
                    key={`${idx}-${p}`}
                    readOnly={true}
                    tooltip={idx + 1}
                  ></PriceUnit>
                );
              })
            : "--"}
        </div>
      </div>
    );
  }
}

class UnitSettingsView extends React.Component {
  render() {
    const { data, networkId } = this.props;

    return (
      <div className="flex flex-col gap-2">
        {data.map((setting, idx) => {
          return (
            <div key={idx} className="flex flex-col gap-2 bg-gray-200 p-2">
              <Title>
                {setting.id} - {setting.name}
              </Title>
              <div>
                <div className="font-semibold text-gray-800">Units</div>
                <UnitsSelector
                  selectedItems={setting.units}
                  disabled={true}
                  networkId={networkId}
                  selectMetric="unitId"
                ></UnitsSelector>
              </div>

              {setting.prices && (
                <div>
                  <PriceItem prices={setting.prices} title="Price" />
                </div>
              )}
              {setting.detector_prices && (
                <div>
                  <PriceItem
                    prices={setting.detector_prices}
                    title="Detector Prices"
                  />
                </div>
              )}
              {setting.catchall_prices && (
                <div>
                  <PriceItem
                    prices={setting.catchall_prices}
                    title="Catchall Prices"
                  />
                </div>
              )}
              {setting.x_prices && (
                <div>
                  <PriceItem prices={setting.x_prices} title="X Prices" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

class Title extends React.Component {
  render() {
    const { children } = this.props;
    return <div className="font-semibold text-gray-900">{children}</div>;
  }
}

export default UprSegmentInfoPopover;
